import { render, staticRenderFns } from "./SchedulerNotes.vue?vue&type=template&id=1036e687&scoped=true&"
import script from "./SchedulerNotes.vue?vue&type=script&lang=js&"
export * from "./SchedulerNotes.vue?vue&type=script&lang=js&"
import style0 from "./SchedulerNotes.vue?vue&type=style&index=0&id=1036e687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036e687",
  null
  
)

export default component.exports